import FAQRepository from '@/repositories/FAQRepository'
import FAQContentEntity from '@/entities/FAQContent'

export interface IPresenterParams {
  FAQRepository: FAQRepository
  contentId: number
}

export interface IPresenter {
  content: FAQContentEntity | null
}

export default ({ FAQRepository, contentId }: IPresenterParams): IPresenter => {
  return {
    content: FAQRepository.getContent(contentId)
  }
}
